export const VENUE_ADDRESS_DISPLAY_LABELS = {
  MODAL_HEADER_FALLBACK: 'Location',
  GET_DIRECTIONS: 'Get Directions',
  CLOSE: 'Close',
  EVENT_DETAILS: 'Event Address Details',
  DETAILS: 'Details'
} as const;
